
export default {
  layout: "blue",
  head() {
    return {
      title: this.data.metaTitle,
      description: this.data.metaDescription,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.data.metaDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.data.keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.data.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.data.metaDescription,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: this.$nuxt.$route.path,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "website",
        },
        { hid: "robots", name: "robots", content: this.$config.robots_tag },
      ],
      script: [
        {
          json: {
            "@context": "https://schema.org",
            "@type": "Website",
            url: this.$nuxt.$route.path,
            name: this.data.schemaJson,
          },
          type: "application/ld+json",
        },
      ],
    };
  },

  computed: {
    isHideContent() {
      return [
        "/landing-jamstack/",
        "/landing-django/",
        "/landing-nodejs/",
        "/landing-nextjs/",
        "/landing-vuejs/",
        "/landing-agence-seo/",
        "/landing-headless-cms/",
        "/landing-python/",
        "/landing-flutter/",
        "/landing-react/",
        "/landing-ruby-on-rails/",
        "/landing-strapi/",
        "/landing-react-native/",,
      ].includes(this.$route.path);
    },
  },
  async asyncData({ app, $strapi, params, route }) {
    let url;
    let hasEnglish;
    let data;
    try {
      data = await $strapi.find(`pages/${params.slug}`);
      if (data === "Not found") {
        data = await $strapi.find(`technologies/${params.slug}`);
      }

      data.section.isLanding = [
        "/landing-jamstack/",
        "/landing-django/",
        "/landing-nodejs/",
        "/landing-nextjs/",
        "/landing-vuejs/",
        "/landing-agence-seo/",
        "/landing-headless-cms/",
        "/landing-python/",
        "/landing-flutter/",
        "/landing-react/",
        "/landing-ruby-on-rails/",
        "/landing-strapi/",
        "/landing-react-native/",
      ].includes(route.path);
      
    } catch (err) {
      console.log("_slug (Pages)");
      console.log("Cannot find ");
      console.error(err);
      console.error({ statusCode: 404, message: err.response });
    }

    return { data, hasEnglish };
  },
};
